import { Col } from 'antd';
import React from 'react';
import { timelineSortOptions } from './TimelineSortOptions';
import { ModifiedByFilter } from './ModifiedByFilter';
import { SearchFilterContainer, SortByFilter } from '../filters';
export const TimelineSearch = ({ onChange, sonarObjectId, queryParams }) => React.createElement(SearchFilterContainer, null,
    React.createElement(Col, { span: 12 },
        React.createElement(ModifiedByFilter, { onChange: onChange, sonarObjectId: sonarObjectId })),
    React.createElement(Col, { className: 'align-right', span: 12 },
        React.createElement(SortByFilter, { defaultSortOption: timelineSortOptions[0], onChange: onChange, options: timelineSortOptions, queryParams: queryParams })));
